// «بیماران» — the list, its toolbar and its states — plus the patient form that
// both the create dialog and the edit drawer render.
export const patients = {
  // ── patients — the list ──────────────────────────────────────────────
  'patients.title': 'Practice patients',
  'patients.sub': 'Imaginary patients you built to practise on.',
  'patients.new': 'New patient',
  'patients.search': 'Search patients…',
  'patients.count': '{{count}} patients',
  'patients.filters.active': 'Active',
  'patients.filters.draft': 'Draft',
  'patients.filters.archived': 'Archived',
  'patients.filters.all': 'All',
  'patients.sort.label': 'Sort',
  'patients.sort.lastVisit': 'Last visit',
  'patients.sort.newest': 'Newest',
  'patients.sort.name': 'Name',
  'patients.columns.name': 'Name / label',
  'patients.columns.age': 'Age · sex',
  'patients.columns.complaint': 'Chief complaint',
  'patients.columns.visits': 'Visits',
  'patients.columns.lastVisit': 'Last visit',
  'patients.columns.status': 'Status',
  'patients.columns.actions': 'Actions',
  'patients.status.draft': 'Draft',
  'patients.status.active': 'Active',
  'patients.status.archived': 'Archived',
  'patients.empty.title': 'No patients yet',
  'patients.empty.body': 'Patients here are imaginary — invent one and start practising.',
  'patients.noMatch.title': 'Nothing matches that search',
  'patients.noMatch.body': 'Clear the filter to see all your patients.',
  'patients.error.title': 'Could not load your patients',
  'patients.error.body': 'The server did not answer. Nothing was lost.',
  'patients.capped': 'More than 100 patients; search to find one faster.',
  'patients.delete.title': 'Delete this patient?',
  'patients.delete.body': '{{entries}} history entries, {{visits}} visits and {{threads}} conversations go with it. There is no undo, and Parseh already spent is not refunded. To keep the work, archive instead.',
  'patients.delete.confirm': 'Delete permanently',
  'patients.deleted': 'The patient was deleted.',
  'patients.created': 'The patient was created.',
  'patients.createdHint': 'Write the history, or dictate it.',
  'patients.archived': 'Archived.',
  'patients.unarchived': 'Back in the active list.',
  'patients.actions.open': 'Open record',
  'patients.actions.startVisit': 'Start visit',
  'patients.actions.chat': 'Chat',
  'patients.actions.archive': 'Archive',
  'patients.actions.unarchive': 'Unarchive',
  'patients.actions.delete': 'Delete',
  'patients.actions.clearFilters': 'Clear filters',
  'patients.openLabel': 'Open {{title}}',
  'patients.moreLabel': 'More actions for {{title}}',
  'patients.unnamed': 'Unnamed patient',
  'patients.visitsCount': '{{count}} visits',
  'patients.noVisits': 'No visits',

  // ── the patient form — create and edit ───────────────────────────────
  'caseForm.title.create': 'New practice patient',
  'caseForm.title.edit': 'Edit patient',
  'caseForm.fields.title': 'Title',
  'caseForm.fields.titlePlaceholder': 'A 54-year-old man with chest pain',
  'caseForm.fields.titleHelper': 'What YOU call this patient in your list.',
  'caseForm.fields.displayName': 'Made-up name',
  'caseForm.fields.displayNamePlaceholder': 'Mr. Rezaei',
  'caseForm.fields.displayNameHelper': 'Invent one so the record reads naturally. Never a real person’s name.',
  'caseForm.fields.ageYears': 'Age in years',
  'caseForm.fields.ageDisplay': 'Age, in another unit',
  'caseForm.fields.ageDisplayPlaceholder': '6 months',
  'caseForm.fields.ageDisplayHelper': 'Overrides the years, for a paediatric or neonatal case.',
  'caseForm.fields.sex': 'Sex',
  'caseForm.fields.bloodType': 'Blood type',
  'caseForm.fields.weightKg': 'Weight (kg)',
  'caseForm.fields.heightCm': 'Height (cm)',
  'caseForm.fields.chiefComplaint': 'Chief complaint',
  'caseForm.fields.chiefComplaintPlaceholder': 'Crushing chest pain since this morning',
  'caseForm.fields.chiefComplaintHelper': 'One line. The full story goes in the history.',
  'caseForm.fields.status': 'Status',
  'caseForm.fields.note': 'Note to yourself',
  'caseForm.submit.create': 'Create patient',
  'caseForm.submit.edit': 'Save changes',
  'caseForm.validation.title': 'A title is required.',
};

export default patients;
